var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgVisa = _a => {
  var _b;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#00579F"
  }), React.createElement("path", {
    d: "M14.5333 19.0172H12.7512L13.8658 12.1248H15.6479L14.5333 19.0172Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M20.9938 12.2933C20.6423 12.1539 20.0847 11.9999 19.3953 11.9999C17.6354 11.9999 16.3961 12.9384 16.3885 14.2801C16.3739 15.2701 17.2758 15.8199 17.9504 16.15C18.6399 16.4873 18.8743 16.7074 18.8743 17.0081C18.8672 17.4698 18.3171 17.6827 17.804 17.6827C17.0925 17.6827 16.7113 17.5729 16.1319 17.316L15.8972 17.2059L15.6478 18.7531C16.0658 18.9435 16.8359 19.1125 17.6354 19.1199C19.5054 19.1199 20.7228 18.1959 20.7372 16.7661C20.7443 15.9815 20.2681 15.3803 19.2413 14.889C18.618 14.5737 18.2362 14.361 18.2362 14.0383C18.2435 13.745 18.5591 13.4445 19.2627 13.4445C19.8421 13.4298 20.2678 13.5691 20.5902 13.7085L20.7514 13.7816L20.9938 12.2933Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M23.3624 16.5755C23.5092 16.1795 24.0739 14.647 24.0739 14.647C24.0665 14.6618 24.2204 14.2438 24.3084 13.9872L24.4329 14.5811C24.4329 14.5811 24.7704 16.2309 24.8437 16.5755C24.5652 16.5755 23.7144 16.5755 23.3624 16.5755ZM25.5622 12.1248H24.1837C23.7586 12.1248 23.4357 12.2494 23.2523 12.6967L20.6051 19.0171H22.4751C22.4751 19.0171 22.7829 18.1664 22.8491 17.9832C23.0542 17.9832 24.8733 17.9832 25.1372 17.9832C25.1884 18.2252 25.3499 19.0171 25.3499 19.0171H27L25.5622 12.1248Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M11.2627 12.1248L9.51734 16.8248L9.32662 15.8716C9.00394 14.7717 7.99198 13.5767 6.86267 12.9825L8.46132 19.0099H10.3459L13.1471 12.1248H11.2627Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M7.89664 12.1248H5.02933L5 12.2641C7.23668 12.836 8.71799 14.2147 9.3266 15.8719L8.70328 12.7042C8.60066 12.264 8.28529 12.1393 7.89664 12.1248Z",
    fill: "#FAA61A"
  }));
};
export default SvgVisa;